module.exports = __webpack_public_path__ + "assets/img/yx.2f66e40d.png";